import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../app';

const socketBaseUrl = import.meta.env.VITE_SOCKET_URL;

function useSocket() {
  const token = useSelector((state: RootState) => state.auth.token);

  return useCallback(() => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(`${socketBaseUrl}v1/app-user-channel/?token=${token}`);
      }, 2000);
    });
  }, [token]);
}

export default useSocket;
